import { Check, MessageCircle } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { ValuationForm } from "@/pages/Sell";
import { useSeo } from "@/hooks/useSeo";
import { useSite } from "@/lib/site";

const CRITERIA = ["Up to two owners", "Full service history", "No MOT failures"];
const EXTRAS = ["Collection anywhere", "Sale or return considered"];
const STEPS = [
  ["Send us the details", "Tell us about your 4x4 using the short form below. Photos help, but are optional."],
  ["We review it personally", "We look over every vehicle ourselves and come back to you with an initial appraisal."],
  ["We collect from anywhere", "If it is right for us, we arrange collection wherever you are. Sale or return is considered."],
];

export default function WeAreBuying() {
  useSeo({ title: "We're Buying Quality 4x4s | Cirencester 4x4", description: "Cirencester 4x4 is actively looking for 4x4s with up to two owners, full service history and no MOT failures. Collection anywhere. Sale or return considered.", path: "/we-are-buying" });
  const site = useSite();
  const wa = `https://wa.me/${(site.whatsapp || "").replace(/\D/g, "")}`;
  return (
    <main data-testid="we-are-buying-page">
      <PageHero eyebrow="We're buying" title="Actively looking for quality 4x4s." sub="Carefully selected. Properly prepared." image="/img/rr10b_front_right.webp">
        <ul className="mt-8 space-y-3" data-testid="buying-criteria">
          {CRITERIA.map((c) => (
            <li key={c} className="flex items-center gap-3 text-lg font-semibold text-charcoal"><span className="grid h-7 w-7 place-items-center rounded-full bg-forest text-paper"><Check className="h-4 w-4" /></span>{c}</li>
          ))}
        </ul>
        <p className="mt-6 text-base text-charcoal/80" data-testid="buying-extras">{EXTRAS.join("  ·  ")}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <a href="#valuation" className="btn btn-primary" data-testid="buying-cta-valuation">Get my valuation</a>
          <a href={wa} target="_blank" rel="noreferrer" className="btn btn-secondary" data-testid="buying-cta-whatsapp"><MessageCircle className="h-4 w-4" /> WhatsApp {site.phone}</a>
        </div>
      </PageHero>

      <section className="border-b border-stone bg-forest text-paper" data-testid="buying-steps">
        <div className="mx-auto grid max-w-[1440px] gap-10 px-5 py-16 sm:px-8 md:grid-cols-3 lg:px-12 lg:py-20">
          {STEPS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.08}>
              <p className="font-serif text-5xl italic text-stone">{i + 1}</p>
              <h2 className="mt-3 text-lg font-semibold">{t}</h2>
              <p className="mt-2 text-sm leading-relaxed text-paper/85">{d}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <ValuationForm leadSource="Instagram - We're buying" />
    </main>
  );
}
